import React from "react";
import vege from "../img/vege.jpg";
function aqua() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="aqua"
    >
      <div className="py-2 flex-1 flex items-center relative">
        {
          <img
            src={vege}
            className="ml-auto h-420 w-full lg:w-auto lg:h-300"
            alt="img"
          />
        }
      </div>
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <p className="text-[2rem] lg:text-[2rem] font-bold tracking-wide text-slate-700">
        Know How Your Food Grows
        </p>
        <p className="text-base text-slate-400 text-center md:text-left md:w-[80%]">
          Knowing how your food Grows is an important part before you {""}
          <span className="text-orange-600">start growing your own food</span> {""}
          Growing vegetables and greens are much easier
          than we think. Having basic knowledge of how the plants grow will ease
          our part in growing them. There are lot of simple and easy Do it
          Yourself methods which we can adopt to grow plants, say for example
          using a wicking bed for water conservation. You don't need to water
          the plant everyday, you can have a wonderful week long vacation
          without worrying about watering the plant. Aquaponics is a easy ,
          natural way of growing food, along with nutritious fishes, most
          importantly in a Organic way. Aquaponics maintain the life cycle of
          living Eco system, hence it's very much Organic and natural way if
          growing vegetables and fish. Read more about Aquaponics on our Know
          How Your Food Grows series.
        </p>
      </div>
    </section>
  );
}

export default aqua;
